<template>
  <div class="container">
    <head-nav-bar title="筛查记录" :fixed="true" />
    <div class="mt-header-nav">
      <van-form @submit="onSubmit">
        <van-field
          v-model="PatientIdentityNo"
          name="PatientIdentityNo"
          label="身份证号"
          placeholder="请填写身份证号"
        />
        <van-field
          v-model="DiagnosisCardNo"
          name="DiagnosisCardNo"
          label="就诊卡号"
          placeholder="就诊卡号"
        />
        <!-- required
          :rules="[{ required: true, message: '请填写就诊卡号' }]" -->
        <van-field
          v-model="PatientName"
          name="PatientName"
          label="患者姓名"
          placeholder="患者姓名"
          required
          :rules="[{ required: true, message: '请填写患者姓名' }]"
        />
        <div style="margin: 16px">
          <!-- :disabled="cannotSubmit" -->
          <van-button round block type="info" native-type="submit"
            >搜索</van-button
          >
        </div>
      </van-form>

      <div class="checkForm" v-if="checkData.patientName">
        <div class="title">
          <p>{{ hospitalInfo.fullName }}</p>
          <p style="margin: 0.2rem 0">{{ checkData.screeningFormName }}</p>
          <p class="time">填写时间：{{ checkData.creationTime }}</p>
        </div>
        <van-cell size="large">
          <template #title>
            <van-tag type="primary">患者</van-tag>
          </template>
        </van-cell>
        <div class="basicInfo">
          <van-row>
            <van-col span="12">卡号: {{ checkData.diagnosisCardNo }}</van-col>
            <van-col span="12">患者姓名: {{ checkData.patientName }}</van-col>
          </van-row>
          <van-row>
            <van-col span="12"
              >性别: {{ checkData.patientSex == 1 ? "男" : "女" }}</van-col
            >
            <van-col span="12">年龄: {{ checkData.patientAge }}</van-col>
          </van-row>
          <van-row>
            <van-col span="12">科室: {{ checkData.departmentName }}</van-col>
            <van-col span="12"
              >电话: {{ checkData.patientContactPhone }}</van-col
            >
          </van-row>
          <van-row>
            <van-col span="24"
              >身份证号: {{ checkData.patientIdentityNo }}</van-col
            >
          </van-row>
          <van-row>
            <van-col span="24"
              >现住址: {{ checkData.patientContactAddress }}</van-col
            >
          </van-row>
          <van-row>
            <van-col span="24"
              >需要陪护人:
              {{ checkData.hasAccompanyPerson == true ? "是" : "否" }}</van-col
            >
          </van-row>
        </div>
        <div v-if="checkData.hasAccompanyPerson">
          <van-cell size="large">
            <template #title>
              <van-tag type="warning">陪护人</van-tag>
            </template>
          </van-cell>
          <div class="basicInfo">
            <van-row>
              <van-col span="12"
                >陪护姓名: {{ checkData.accompanyName }}</van-col
              >
              <van-col span="12"
                >与患者关系: {{ checkData.relationTypeDesc }}</van-col
              >
            </van-row>
            <van-row>
              <van-col span="24">电话: {{ checkData.accompanyPhone }}</van-col>
            </van-row>

            <van-row>
              <van-col span="24"
                >身份证号: {{ checkData.accompanyIdentityNo }}</van-col
              >
            </van-row>
            <van-row>
              <van-col span="24"
                >现住址: {{ checkData.accompanyContactAddress }}</van-col
              >
            </van-row>
          </div>
        </div>
        <van-cell size="large">
          <template #title>
            <van-tag type="danger">流行病学史</van-tag>
          </template>
        </van-cell>
        <div
          class="detailsBox"
          v-for="(item, index) in checkData.details"
          :key="index"
          style="marginbottom: 0.2rem"
        >
          {{ index + 1 }}.{{ item.optionTemplateTitle }}
          <!-- 患者 -->
          <div class="answer">
            <p v-if="item.mainOperateTypeDesc">
              患者选项：{{ item.mainOperateTypeDesc
              }}<span
                v-if="item.mainOperateItemText"
                style="marginleft: 0.2rem"
                >{{ item.mainOperateItemText }}</span
              >
            </p>
            <p v-if="item.mainOperateRemark">
              患者备注：{{ item.mainOperateRemark }}
            </p>
            <p v-if="item.accompanyOperateTypeDesc">
              陪护人选项：{{ item.accompanyOperateTypeDesc
              }}<span
                v-if="item.accompanyOperateItemText"
                style="marginleft: 0.2rem"
                >{{ item.accompanyOperateItemText }}</span
              >
            </p>
            <p v-if="item.accompanyOperateRemark">
              陪护人备注：{{ item.accompanyOperateRemark }}
            </p>
          </div>
        </div>
        <div
          style="
            width: 100%;
            textalign: center;
            font-size: 0.4rem;
            padding: 0.5rem 0 0 0;
          "
        >
          筛查结果：<van-tag
            :type="checkData.resultDesc == '合格' ? 'success' : 'danger'"
            size="large"
            >{{ checkData.resultDesc }}</van-tag
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  Form,
  Field,
  Button,
  RadioGroup,
  Radio,
  Cell,
  CellGroup,
  Popup,
  Picker,
  Tag,
  Switch,
  Dialog,
  Overlay,
  Row,
  Col,
  Toast
} from "vant";
export default {
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Tag.name]: Tag,
    [Switch.name]: Switch,
    [Overlay.name]: Overlay,
    [Col.name]: Col,
    [Row.name]: Row
  },
  computed: {
    ...mapState({
      hospitalInfo: state => state.app.hospitalInfo
    })
  },
  created() {
    if (!(this.hospitalInfo && this.hospitalInfo.Id)) {
      this.getHospitalInfo();
    }
    const query = this.$route.query;
    setTimeout(() => {
      if (query) {
        if (query.DiagnosisCardNo && query.PatientName) {
          this.DiagnosisCardNo = query.DiagnosisCardNo;
          this.PatientName = query.PatientName;
          this.onSubmit();
        }
      }
    }, 1000);
  },
  data() {
    return {
      DiagnosisCardNo: "",
      PatientName: "",
      checkData: {},
      cannotSubmit: true,
      NoContact: false,
      PatientIdentityNo: ""
    };
  },
  methods: {
    ...mapActions(["getHospitalInfo"]),
    onSubmit() {
      if (!this.DiagnosisCardNo && !this.PatientIdentityNo) {
        Toast.fail("身份证、就诊卡号必填一项");
        return;
      }
      this.$post("GetScreeningForm_RecordInfo", {
        DiagnoseCardNo: this.DiagnosisCardNo,
        PatientName: this.PatientName,
        PatientIdentityNo: this.PatientIdentityNo
      }).then(res => {
        if (res.data.length) {
          this.checkData = res.data[0];
          this.checkData.patientSex += "";
          this.checkData.patientIdentityNo = this.checkData.patientIdentityNo
            ? this.checkData.patientIdentityNo.substr(0, 3) +
              "******" +
              this.checkData.patientIdentityNo.substr(14)
            : "";
          this.checkData.accompanyIdentityNo = this.checkData
            .accompanyIdentityNo
            ? this.checkData.accompanyIdentityNo.substr(0, 3) +
              "******" +
              this.checkData.AccompanyIdentityNo.substr(14)
            : "";
        } else {
          this.checkData = {};
          Dialog({ message: "未查询到筛查记录！" });
        }
      });
    },
    handleCardNoChange(e, name) {
      let value = "";
      if (e && e !== "") {
        value = e.target.value;
      } else if (name) {
        value = name;
      }
      if (value) {
        this.cannotSubmit = false;
        return;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  .title {
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 0.5rem;
    margin-bottom: 0.5rem;
    .time {
      font-size: 0.4rem;
      font-weight: 300;
    }
  }

  .fieldBox {
  }

  .needHasAccompanyPerson {
    padding-left: 0.4rem;
    font-size: 0.4rem;
    color: red;
  }
  .TemplateText {
    font-size: 0.4rem;
    padding: 0 0.4rem;
  }
  .detailsBox {
    padding: 0 0.4rem;
    font-size: 0.4rem;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .block {
      padding: 0.5rem 1rem;
      border-radius: 5px;
      background-color: #fff;
      font-size: 0.4rem;
      font-weight: bold;
    }
  }
  .answer {
    margin-top: 0.2rem;
    color: #999;
  }
  .checkForm {
    // text-align: center;
    box-sizing: border-box;
    font-size: 0.37rem;
    color: #646566;
    .basicInfo {
      padding: 0 0.4rem;
    }
  }
}
</style>
